var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intl-layout" },
    [
      _c("IntlHeader"),
      _vm._v(" "),
      _c("main", { staticClass: "intl-layout__main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("IntlFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }